export const RIGHTS_TYPE = {
  /**
   * 最高权限
   */
  AUTHORITY_SETTING: "999999",

  /**
   * 权限查询
   */
  AUTHORITY_QUERY: "999998",

  /**
   * 风控系统
   */
  RISK_SYSTEM: "270001",

  /**
   * 用户系统 - KYC认证审批
   */
  APPROVE_KYC: "10100",

  /**
   * 用户系统 - KYC认证审批查询
   */
  APPROVE_KYC_QUERY: "10101",

  /**
   * 用户系统 - 用户身份信息
   */
  USER_IDENTITY_INFO: "10200",

  /**
   * 用户系统 - 子账号信息
   */
  USER_SUB_INFO: "10205",
  /**
 * 用户系统 - 任务考核数据
 */
  USER_TASK_INFO: "10207",

  /**
   * 用户系统 - 用户地址信息
   */
  USER_ADDRESS_INFO: "10201",

  /**
   * 用户系统 - 用户地址信息查询
   */
  USER_ADDRESS_QUERY: "10208",

  /**
   * 用户系统 - 用户地址信息
   */
  USER_Withdrawal_ADDRESS_INFO: "10209",


  /**
   * 用户系统 - 用户身份修改
   */
  USER_MSG_ALTER: "10202",

  /**
   * 用户系统 - 用户标签信息
   */
  USER_TAG_INFO: "10203",

  /**
   * 用户系统 - 用户标签信息查询
   */
  USER_TAG_DELETE: "10204",

  /**
   * 用户系统 - 用户身份信息查询
   */
  USER_IDENTITY_QUERY: "10207",

  /**
   * 用户系统 - 子账号查询
   */
  USER_SUB_QUERY: "10210",

  /**
   * 用户系统 - 项目方管理
   */
  PROJECT_MANAGE: "10300",

  /**
   * 用户系统 - 项目方余额信息查询
   */
  PROJECT_BALANCE: "10301",

  /**
   * 用户系统 - 项目方管理删除
   */
  // PROJECT_BALANCE: "10302",

  /**
   * 用户系统 - c2c商户设置
   */
  MERCHANT_MAINTAIN: "10400",

  /**
   * 用户系统 - 部落资料审批
   */
  APPROVE_TRIBE_INFO: "10500",

  /**
   * 用户系统 - 用户账单
   */
  USER_BILL: "10600",

  /**
   * 用户系统 - 工单处理 -- 登录用户
   */
  WORK_ORDER_USER_LOGIN: "10700",

  /**
   * 用户系统 - 工单处理 -- 未登录用户
   */
  WORK_ORDER_USER_NO_LOGIN: "10701",

  /**
   * 交易系统 - 做市商管理
   */
  MARKET_MAKER_MANAGE: "10800",

  /**
   * 交易系统 - 交易白名单管理
   */
  TRADE_WHITELIST: "10801",

  /**
   * 财务系统 - 批量归集白名单
   */
  TRANSFER_APPROVAL_WHITELIST: "10802",

  /**
   * 财务系统 - 提现白名单管理
   */
  WITHDRAW_APPROVAL_WHILELIST: "10803",

  /**
   * 用户系统 - 用户余额快照
   */
  USER_BALANCE_SNAPSHOT: "10900",

  /**
   * 用户系统 - 币评论
   */
  USER_COIN_COMMENT: "11000",

  /**
   * 用户系统 - 运营人员工单
   */
  WORK_ORDER_EN_OPERATE: "140001",

  /**
   * 用户系统 - 研发人员工单
   */
  WORK_ORDER_EN_DEVELOP: "140002",

  /**
   * 充提系统 - 充值审核
   */
  APPROVE_DEPOSIT: "20100",

  /**
   * 充提系统 - 设置提现手续费
   */
  SYSTEM_COIN_WITHDRAW_FEE_QUERY: "20308",

  /**
   * 充提系统 - 充值审核查询
   */
  APPROVE_DEPOSIT_QUERY: "20101",

  /**
   * 充提系统 - 大额充值复审
   */
  APPROVE_LARGE_DEPOSIT: "20102",

  /**
   * 充提系统 - 手工录入充值
   */
  DEPOSIT_MANUAL: "20103",

  /**
   * 充提系统 - 入账审核配置
   */
  ENTER_ACCOUNT_AUDIT_CONFIG: "20104",

  /**
   * 充提系统 - 入账人工审核
   */
  ENTER_ACCOUNT_AUDIT_MANUAL: "20105",

  /**
   * 充提系统 - 充值内部状态变更
   */
  DEPOSIT_INNER_STATUS_CHANGE: "20106",

  /**
   * 充提系统 - 充值限制
   */
  DEPOSIT_LIMIT: "20107",

  /**
   * 充提系统 - 提现审批
   */
  APPROVE_WITHDRAW: "20200",

  /**
     * 充提系统 - 提现过审配置
     */
  AUTO_APPROVAL_WITHDRAW: '20305',

  /**
   * 充提系统 - 热门币种配置
   */
  // HOT_COIN_CONFIG: '20304',

  /**
   * 充提系统 - 提现审批查询
   */
  APPROVE_WITHDRAW_QUERY: "20201",

  /**
   * 充提系统 - 二次提现审批
   */
  RE_APPROVE_WITHDRAW: "20202",

  /**
   * 充提系统 - 提现录入
   */
  TX_MAINTAIN: "20203",

  /**
   * 充提系统 - 币种设置
   */
  SYSTEM_COIN_TYPE_SETTING: "20300",

  /**
   * 充提系统 - 币种介绍设置
   */
  SYSTEM_COIN_TYPE_INTRODUCE: "20301",

  /**
   * 充提系统 - 充提币提醒设置
   */
  SYSTEM_COIN_REMIND: "20302",

  /**
   * 充提系统 - 站内提现审批
   */
  WITHDRAW_INTERNAL_AUDIT: "20205",

  /**
   * 充提系统 - 站内提现审批
   */
  PARTNER_BALANCE_COLLECT: "20206",

  /**
   * 账务系统 - 转账上传
   */
  INNER_TRANSFER_UPLOAD: "30100",

  /**
   * 账务系统 - 转账币种配置
   */
  TRANSFER_COIN_SET: "30101",

  /**
   * 账务系统 - 空投设置
   */
  AIRDROP_SETTING: "30200",

  AIRDROP_COIN_SETTING: "30201",

  /**
   * 账务系统 - 转账记录查询
   */
  TRANSFER_RECORD_QUERY: "30300",

  /**
   * 账务系统 - 市值账户转账记录查询
   */
  TRANSFER_RECORD_SHIZHI_QUERY: "30400",

  /**
   * 账务系统 - 对账查询
   */
  RECONCILIATION_QUERY: "30500",

  /**
   * 账务系统 - 实时生成钱包余额快照
   */
  WALLET_QUERY_BALANCE: "30506",

  /**
   * 账务系统 - 对账配置
   */
  RECONCILIATION_CONFIG: "30501",

  /**
   * 账务系统 - 手动对账
   */
  RECONCILIATION_MANUAL: "30502",

  /**
   * 账务系统 - 钱包对账管理
   */
  WALLET_RECONCILIATION: "30503",

  /**
   * 账务系统 - 对冲资产流水
   */
  HEDGE_BALANCE_BOOK: "30504",

  /**
   * 账务系统 - PSI分红
   */
  PSI_BONUS_DISTRIBUTE: "30505",

  /**
   * 账务系统 - PSI分红结算
   */
  PSI_PAIR_BONUS: "30701",

  /**
   * 理财系统 - 活期宝设置
   */
  SYSTEM_CURRENT_INTEREST: "40100",

  /**
   * 理财系统 - 币存生息(定期宝)
   */
  PLEDGE_INTEREST_PROJECT: "40200",

  /**
   * 理财系统 - 借贷宝配置
   */
  MORTGAGE_MANAGE_CONFIG: "40300",

  /**
   * 理财系统 - 借贷宝订单管理
   */
  MORTGAGE_MANAGE_ORDER: "40400",

  /**
   * 理财系统 - 挖矿宝利率管理
   */
  USER_MINING_RATE: "40500",

  /**
   * 理财系统 - 挖矿宝订单管理
   */
  USER_MINING_AWARD: "40600",

  /**
   * 理财系统 - 活期挖矿配置管理
   */
  USER_MINING_CONFIG: "40800",

  /**
   * 理财系统 - 定期挖矿配置管理
   */
  MINING_REGULAR_CONFIG: "40900",

  /**
   * 理财系统 - 定期挖矿订单管理
   */
  MINING_REGULAR_ORDER: "41000",

  /**
   * 理财系统 - 新币挖矿配置管理
   */
  MINING_NEW_COIN_CONFIG: "41100",

  /**
   * 理财系统 - 活期挖矿配置管理
   */
  MINING_ALIVE_REGULAR_CONFIG: "41200",

  /**
   * 理财系统 - 基金管理
   */
  FUND_MANAGEMENT: "103000",

  /**
   * 理财系统 - staking配置
   */
  STAKING: "108000",

  /**
   * 理财系统 - staking锁仓
   */
  STAKING_LOCK: "108001",

  /**
   * 理财系统 - staking解锁
   */
  STAKING_UNLOCK: "108002",

  /**
   * 理财系统 - staking收益
   */
  STAKING_INCOME: "108003",

  /**
   * 理财系统 - staking统计查询
   */
  STAKING_COUNT: "108004",

  /**
   * 交易系统 - C2C 订单审批
   */
  APPROVE_C2C_ORDER: "50100",

  /**
   * 交易系统 - 交易对设置
   */
  SYSTEM_PAIR_SETTING: "50200",

  /**
   * 交易系统 - 交易区设置
   */
  SYSTEM_TRADE_SET_SETTING: "50300",

  /**
   * 交易系统 - 交易活动 -- 活动设置
   */
  TRADE_ACTIVITY_SET: "50400",

  /**
   * 交易系统 - 交易活动 -- 排行榜查看
   */
  TRADE_ACTIVITY_QUERY: "50401",

  /**
   * 交易系统 - 交易统计 -- 交易对平均买入成本
   */
  TRADE_PAIR_AVG_COST: "50500",

  /**
   * 交易系统 - 交易统计 -- 交易对订单数
   */
  TRADE_PAIR_ORDER_NUM: "50501",

  /**
   * 交易系统 - 交易统计 -- 持仓数据
   */
  POSITION_INFO: "50502",

  /**
   * 交易系统 - 交易统计 -- 快照持仓
   */
  SNAP_POSITION: "50503",

  /**
   * 交易系统 - 单个用户交易数据导出（给审核用的）
   */
  EXPORT_USER_TRADE_DEAL: "50504",

  /**
   * 交易系统 - 交易异常处理
   */
  TRADE_EXCEPTION: "50600",

  /**
   * 交易系统 - 项目方机器人
   */
  TRADERS: "50700",

  /**
   * 交易系统 - 机器人设置 --平滑上攻机器人
   */
  ROBOT_AUTO_DEAL: "50702",

  /**
   * 交易系统 - 行情同步策略 --
   */
  QUOTATION_SYNC_SET: "50703",

  /**
   * 机器人设置 --冰山策略,定时操盘，铺单，反向挂单，盘面活跃
   */
  MACHINE_STRATEGY_COINFIG: "220002",

  /**
   * 交易系统 - 对冲管理
   */
  HEDGE_MANAGE: "50704",

  /**
   * 交易系统 - 对冲策略
   */
  HEDGE_STRATEGY: "50705",

  /**
   * 交易系统 - 中间刷量配置
   */
  BRUSH_CONFIG_SET: "50706",

  /**
   * 交易系统 - 新对冲统计
   */
  NEW_HEDGE_MANAGE: "50707",

  /**
   * 交易系统 - 新对冲策略
   */
  NEW_HEDGE_STRATEGY: "50708",

  /**
   * 交易系统 - 新对冲策略（读）
   */
  NEW_HEDGE_STRATEGY_READ: "50709",

  /**
   * 交易系统 - 新对冲策略（写）
   */
  NEW_HEDGE_STRATEGY_UPDATE: "50710",

  /**
   * 交易系统 - 新对冲原始记录
   */
  NEW_HEDGE_SRC_RECORDS: "50711",

  /**
   * 交易系统 - 新对冲合并记录
   */
  NEW_HEDGE_BATCH_RECORDS: "50712",

  /**
   * 交易系统 - 添加人工成功对冲记录
   */
  NEW_HEDGE_ADD_MANUAL_RECORD: "50713",

  /**
   * 交易系统 - 财务对账
   */
  HEDGE_BALANCE_RECONCILIATION: "50714",

  /**
   * 交易系统 - 停盘预警
   */
  TRADE_STOP_TRADING_ALARM: "50716",

  /**
   * 交易系统 - 盘口价差预警
   */
  TRADE_PRICE_DIFFERENCE_ALARM: "50717",

  /**
   * 交易系统 - 价格预警
   */
  TRADE_PRICE_ALARM: "50718",

  /**
   * 交易系统 - 防板砖预警
   */
  TRADE_MOVING_BRICKS_ALARM: "50719",

  /**
   * 交易系统 - 深度不足预警
   */
  TRADE_INSUFFICIENT_DEPTH_ALARM: "50720",

  /**
   * 交易系统 - 监控警告
   */
  RISK_CONTROL_WARNING: "50721",

  /**
   * 交易系统 - 盘口做市区分
   */
  MARKET_POSITION_USER_DISTINGUISH: "50722",

  /**
   * 交易系统 - 更新REDIS分布式锁UUID
   */
  UPDATE_REDIS_LOCK_CONTROL_UUID: "50723",

  /**
   * 交易系统 - 删除特殊缓存
   */
  CACHE_DELETE: "110002",

  /**
   * 交易系统-虚拟深度
   */
  INVENT_DEPTH_CONFIG: "50730",
  /**
   * ETP业务系统 - ETP合并
   */
  ETP_MERGE: "110001",

  /**
   * ETP业务系统 - 榜单管理
   */
  ETP_COIN_SHOW_CONFIG: "110003",

  /**
   * OTC业务系统 - OTC 商户申请
   */
  OTC_MERCHANT_APPLY: "60100",

  /**
   * OTC业务系统 - OTC 商户升级
   */
  OTC_MERCHANT_UPGRADE: "60101",

  /**
   * OTC业务系统 - OTC 商户退出权限
   */
  OTC_MERCHANT_QUIT: "60102",

  /**
   * OTC业务系统 - OTC 商户冻结
   */
  OTC_MERCHANT_FREEZE: "60103",

  /**
   * OTC业务系统 - OTC 收款人审核
   */
  OTC_PAYEE_APPROVE: "60200",

  /**
   * OTC业务系统 - OTC 大额广告审核
   */
  OTC_ADVERTISING_APPROVE: "60201",

  /**
   * OTC业务系统 - OTC 订单审核
   */
  OTC_ORDER_APPROVE: "60202",

  /**
   * OTC业务系统 - OTC 订单申诉
   */
  OTC_ORDER_APPEAL: "60203",
  /**
   * OTC业务系统 - OTC 商户管理
   */
  OTC_MERCHANT_MANAGE: "60104",

  /**
   * OTC业务系统 - OTC 订单查询统计
   */
  OTC_QUERY_COUNT: "60300",

  /**
   * OTC业务系统 - OTC广告币种配置
   */
  OTC_ADVERTISING_COIN: "60400",

  /**
   * OTC业务系统 - OTC手续费配置
   */
  OTC_FEE_CONFIG: "60401",

  /**
   * PORTAL系统 - Banner设置新版
   */
  SYSTEM_BANNER_NEW_SETTING: "70101",

  /**
   * PORTAL系统 - 内容设置
   */
  SYSTEM_CONTENT_SETTING: "70200",

  /**
   * PORTAL系统 - 邀请海报设置
   */
  SYSTEM_POSTER_SETTING: "70300",

  /**
   * PORTAL系统 - 弹出框设置
   */
  PROMPT: "70500",

  /**
   * PORTAL系统 - 协议录入
   */
  AGREEMENT_ENTRY: "70600",

  /**
   * PORTAL系统 - 榜单配置 - 涨幅榜黑名单
   */
  LIST_GAINS_BLANK: "70700",

  /**
   * PORTAL系统 - 榜单配置 - 人气榜单
   */
  LIST_POPULAR: "70701",

  /**
   * PORTAL系统 - app组件设置
   */
  APP_COMPONENT: "101008",

  /**
   * PORTAL系统 - app金刚区设置
   */
  APP_KING_KONG: "101009",

  /**
   * PORTAL系统 - app产品类型
   */
  APP_PRODUCT_CATEGORY: "101101",
  /**
   * PORTAL系统 - app产品精选
   */
  APP_PRODUCT_SELECTION: "101102",
  /**
   * PORTAL系统 - app产品推荐
   */
  APP_PRODUCT_RECOMMEND: "101103",
  /**
   * 营销系统 - 快讯设置
   */
  SYSTEM_NEWS_SETTING: "80100",


  /**
   * 营销系统 - 推送设置
   */
  SYSTEM_PUSH_SETTING: "80200",

  /**
   * 营销系统 - 发送邮件
   */
  EMAIL_SEND: "80300",

  /**
   * 营销系统 - 验证码记录
   */
  SMS_EMAIL_SEND_RECORD: "80301",
  /**
   * 营销系统 - 邮箱管理
   */
  EMAIL_USER: "80302",

  /**
   * 营销系统 - 用户分组
   */
  EMAIL_USER_GROUP: "80303",

  /**
   * 营销系统 - 卡劵管理
   */
  COUPON_MANAGE: "80400",

  /**
   * 营销系统 - 双十一活动权限
   */
  ACTIVITY_MANAGE: "80500",

  /**
   * 营销系统 - 合约争霸活动权限
   */
  ACTIVITY_CONTRACT: "80600",

  /**
   * 营销系统 - 竞猜 --项目列表
   */
  GUESS_PROJECT: "80700",

  /**
   * 营销系统 - 社区投票 --项目列表
   */
  COMMUNITY_VOTE_PROJECT: "80800",

  /**
   * 营销系统 - 投票设置 --批次设置
   */
  VOTE_BATCH_SETTING: "80801",

  /**
   * 营销系统 - 投票设置 --币种设置
   */
  VOTE_COIN_TYPE_SETTING: "80802",

  /**
   * 营销系统 - 红包管理
   */
  RED_ENVELOPE: "80900",

  /**
   * 云算力 - 挖矿活动奖励
   */
  HASHRATE_MANAGEMENT: "105000",

  /**
   * 币种变基
   */
  COIN_REBASE: "106000",

  /**
   * 营销系统 - 批量发送邮件
   */
  EMAIL_BATCH_SEND: "81000",

  /**
   * 营销系统 - 申购
   */
  PURCHAE_ADMIN: "82000",

  /**
   * 充提系统 - 热门币种配置
   */
  HOT_COIN_CONFIG: "20304",

  /**
   *  账务系统 - 燃烧币种分红
   */
  BURNING_PAIR_BOUNS: "30700",

  /**
   * 营销系统 - 秒杀、团购、投入
   */
  INCUBATOR_ADMIN: "83000",

  /**
   * 营销系统 - 秒杀、团购、投入
   */
  INCUBATOR_CHECK_CALCULATION: "83001",

  /**
   * 营销系统 - 空投转账
   */
  INCUBATOR_AIRDROP_TRANSFER: "84000",

  /**
   * 系统设置 - APP版本设置
   */
  APP_VERSION_SETTING: "90100",

  /**
   * 系统设置 - site_config 设置
   */
  SYSTEM_SITE_CONFIG: "90200",

  /**
   * 系统设置 - 钱包账户设置
   */
  SYSTEM_WALLET_ACCOUNT_SETTING: "90300",

  /**
   * 系统设置 - 钱包开关
   */
  SYSTEM_WALLET_SWITCH: "90301",

  /**
   * 系统设置 - 撤单钱包开关
   */
  CANCEL_ORDER_SWITCH: "90302",

  /**
   * 系统设置 - 手续费设置
   */
  SERVICE_CHARGE_SETTING: "90303",

  /**
   * 系统设置 - Processor设置
   */
  SYSTEM_PROCESSOR_SETTING: "90400",

  /**
   * 系统设置 - 转冷配置与查询
   */
  TRANSFER_COLD_WALLET: "90500",

  /**
   * 系统设置 - 地址管理
   */
  ETH_RUSH_NONCE: "90600",
  /**
   * 合约手续费设置
   */
  CONTRACT_FEE_SHARE: "90501",

  /**
   * 超级合约业务 - 超级合约配置设置
   */
  SYSTEM_SUPER_CONTRACT_CONFIG: "100000",

  /**
   * 超级合约业务 - 超级持仓相关设置
   */
  SYSTEM_SUPER_CONTRACT_ORDER: "100001",

  /**
   * 超级合约业务 - 超级项目方相关设置
   */
  SYSTEM_SUPER_CONTRACT_PROJECT: "100002",

  /**
   * 超级合约业务 - 盈亏统计
   */
  SYSTEM_SUPER_CONTRACT_PROFIT: "100004",

  /**
   * 币安合约业务 - 合约配置
   */
  CONTRACT_SYMBOL_CONFIG: "120001",

  /**
   * 币安合约业务 - 划转记录
   */
  CONTRACT_TRANSFER_MANAGE: "120002",

  /**
   * 币安合约业务 - 交易记录、挂单记录、订单记录、强平记录
   */
  CONTRACT_ORDER_MANAGE: "120003",

  /**
   * 用户信息查询
   */
  CONTRACT_USER_MANAGE: "120004",

  /**
   * 币安合约业务 - 合约统计
   */
  CONTRACT_COUNT_MANAGE: "120005",

  /**
   * 充提可视化数据查询
   */
  DEPOSIT_WITHDRAW_VISUAL: "100100",

  /**
   * 数据中心 - 余额查询
   */
  DATA_CENTRE_BALANCE: "101000",

  /**
   * 数据中心 - 活期宝查询
   */
  DATA_CENTRE_CURRENT: "101001",

  /**
   * 数据中心 - 手续费查询
   */
  DATA_CENTRE_TRADE_FEE: "101002",

  /**
   * 数据中心 - 合约查询
   */
  DATA_CENTRE_CONTRACT: "101003",

  /**
   * 数据中心 - 部落收益查询
   */
  DATA_CENTRE_TRIBE_PROFIT: "101004",

  /**
   * 数据中心 - 充提统计查询
   */
  DATA_CENTRE_DEPOSIT_WITHDRAW: "101005",

  /**
   * 数据中心 - 定期宝数据
   */
  DATA_CENTRE_PLEDGE: "101006",

  /**
   * 数据中心 - 用户数据
   */
  DATA_CENTRE_USER: "101007",

  /**
   * 数据中心 - 扫币设置
   */
  SWEEP_DATA: "101108",

  /**
   * 数据中心 -退币设置
   */
  REFUND_COIN: "101109",

  /**
   * 数据中心 -退币审核
   */
  REVIEW_REFUND_COIN: "101110",

  /**
   * 数据中心 - bkk销毁记录
   */
  BKK_DESTROY_RECORD: "101011",

  /**
   * 数据中心 - 交易量数据
   */
  DATA_TRADE_VOLUME: "101012",

  /**
   * 数据中心 - staking数据
   */
  DATA_CENTRE_STAKING: "101013",

  /**
   * 数据中心 - 上币申请查询
   */
  DATA_CENTRE_LISTING_APPLY: "101014",

  /**
   * 板块管理
   */
  PLATE_MANAGE: "260000",

  /**
   * 财务系统
   */
  FINANCIAL_MANAGE_SYSTEM: '250001',

  /**
   * 资金明细
   */
  FUND_DETAILS: "20230523",

  /**
   * Focus管理
   */
  FOCUS: "260002",

  /**
   * App 动态配置理财管理
   */
  FINANCIAL_MANAGEMENT: "260001",

  /**
   * 竞技场
   */
  ARENA_MANAGEMENT: "104000",

  /**
   * cms系统 内容管理
   */
  CMS_MANAGE_CONTENT: "301001",

  /**
   * cms系统 内容管理(简化)
   */
  CMS_MANAGE_CONTENT_SIMPLIFY: "301002",

  /**
   * cms系统 审核管理
   */
  CMS_MANAGE_REVIEW: "302001",

  /**
   * cms系统 标签库
   */
  CMS_MANAGE_LABEL: "303001",

  /**
   * cms系统 推荐管理
   */
  CMS_MANAGE_RECOMMEND: "304001",

  /**
   * cms系统 栏目管理
   */
  CMS_MANAGE_COLUMN: "305001",

  /**
   * cms系统 统计查询
   */
  CMS_MANAGE_STATISTICS: "306001",

  /**
   * cms系统 币圈信息流
   */
  CMS_MANAGE_MESSAGE: "307001",

  /**
   * 余额快照分析
   */
  SNAPSHOT_STATISTICS: "109000",

  /**
   * 策略管理
   */
  STRATEGY_MANAGE: "110000",

  /**
   * 代理商-ADD
   */
  AGENT_MANAGEMENT: "102002",

  /**
   * 数据分析 资产统计
   */
  DATA_ANALYSIS_ASSET_STATISTICS: "130001",

  /**
   * 营销 分红派送配置
   */
  ZOO_DIVIDE: "83000",

  /**
   * 社区信息管理
   */
  COMMUNITY_MANAGEMENT: "150001",

  /**
   * 充值自动过审配置
   */
  CONFIGURATION_OF_RECHARGE_AUTOMATIC_AUDIT: "",

  /**
   * 交易系统 - 交易对提示配置
   */
  SYSTEM_PAIR_TIP_SETTING: "50202",
  /**
    * 盲盒币种管理（NFT）
    */
  BLIND_BOX_COIN: "180001",

  /**
   * 盲盒管理
   */
  BLIND_BOX: "180002",

  /**
   * NFT提现管理
   */
  BLIND_BOX_COIN_WITHDRAWAL: '180003',

  /**
   * 充提系统-提币链提示信息
   */
  WITHDRAW_CHAIN_PROMPT_CONF: "20306",

  /**
   * 用户系统 - KYC配置
   */
  APPROVE_KYC_CONFIG: "10102",

  /**
   * 用户系统 - 登录注册实名开关
   */
  LOGIN_REGIST_AUTH: "10103",

  /**
   * 数据中心 - 充值退回
   */
  DEPOSITE_REFUND_COIN: "101111",

  /**
   * 用户对账查询
   */
  USER_BILL_statistics: "20230530",

  /**
   * 平台对账查询
   */
  platform_BILL_statistics: "20230531",


  trade_order: "23070101",
  trade_order_detail: "23070102"
};

export const WALLET_TYPES = {
  WALLET: "钱包账户",
  OTC: "法币账户",
  CONTRACT: "合约账户",
  GENERAL: "超级合约账户",
};
